import {ColDef, ColType} from "../interfaces/colDef";
import {ProjectStatus} from "../interfaces/project";

export const stickyColumns: ColDef[] = [{
  name: 'name',
  subtitle: 'explain.project.name',
  type: ColType.STRING,
  required: true,
  disabled: true,
  title: 'name'
}];

export const otherDefs: ColDef[] = [
  {
    title: 'status',
    name: 'status',
    type: ColType.RADIO,
    required: true,
    list: [
      {
        id: ProjectStatus.ACTIVE,
        name: 'Active'
      },
      {
        id: ProjectStatus.ARCHIVED,
        name: 'Archived'
      }
    ]
  }
];

export const stickyScheduleColumns: ColDef[] = [{
  name: 'name',
  subtitle: 'explain.project.name',
  type: ColType.STRING,
  required: true,
  disabled: true,
  sort: false,
  filter: false,
  title: 'name'
}];

export const scheduleColumns: ColDef[] = [
  {
    name: 'scheduled',
    title: 'scheduledhours',
    required: false,
    type: ColType.INT,
    filter: false,
    sort: true
  },
  {
    name: 'offered',
    title: 'offeredtotal',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'cost',
    title: 'cost',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'value',
    title: 'forcastvalue',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'margin',
    title: 'forcastmargin',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'duration',
    title: 'tracking.trackedtime',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CUSTOM
  },
  {
    name: 'tracked_amount',
    title: 'tracking.tracked_amount',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'tracked_scheduled',
    title: 'tracking.tracked_scheduled',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'tracked_budget',
    title: 'tracking.tracked_budget',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'num_members',
    title: 'totalmembers',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'workingdays',
    title: 'workingdays',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  // {
  //   name: 'timeline',
  //   title: 'projecttimeline',
  //   required: false,
  //   filter: false,
  //   sort: 'end_on',
  //   type: ColType.RANGE,
  //   style: {
  //     minWidth: '350px'
  //   },
  //   noexport: true
  // },
  {
    name: 'status',
    title: 'currentstatus',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'max_score',
    title: 'score',
    required: false,
    sort: true,
    filter: false,
    type: ColType.INT,
    noexport: true
  }
];

export const columns: ColDef[] = [
  {
    name: 'description',
    subtitle: 'explain.project.description',
    title: 'description',
    required: false,
    type: ColType.AREA,
    length: 30000
  },
  {
    name: 'start_on',
    subtitle: 'explain.project.start_on',
    title: 'startdate',
    required: false,
    type: ColType.DATE
  },
  // {
  //   name: 'timeline',
  //   subtitle: 'explain.project.timeline',
  //   title: 'project_timeline',
  //   type: ColType.RANGE,
  //   filter: false,
  //   sort: 'end_on',
  //   style: {
  //     minWidth: '350px'
  //   },
  //   required: false,
  //   disabled: false
  // },
  {
    name: 'end_on',
    subtitle: 'explain.project.end_on',
    title: 'enddate',
    required: false,
    type: ColType.DATE
  },
  // {
  //   name: 'due_on',
  //   subtitle: 'explain.project.due_on',
  //   title: 'due',
  //   required: false,
  //   type: ColType.DATE
  // },
  {
    name: 'for_client',
    subtitle: 'explain.project.client',
    title: 'client',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'industry',
    subtitle: 'explain.project.industry',
    title: 'projectindustry',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'skills',
    subtitle: 'explain.project.skills',
    title: 'hardskills',
    required: false,
    filter: false,
    type: ColType.LISTADDER
  },
  {
    name: 'developments',
    subtitle: 'explain.project.developments',
    title: 'softskills',
    required: false,
    filter: false,
    type: ColType.LISTADDER
  },
  {
    name: 'certifications',
    subtitle: 'explain.project.certifications',
    title: 'certifications',
    required: false,
    filter: false,
    type: ColType.LISTADDER
  },
  {
    name: 'member',
    subtitle: 'explain.project.member',
    title: 'members',
    required: false,
    type: ColType.LISTADDER
  }
];

export const invitedColumns: ColDef[] = [
  {
    name: 'project',
    title: 'project',
    required: true,
    sort: false,
    filter: false,
    type: ColType.LISTADDER
  },
  {
    name: 'for_client',
    title: 'client',
    required: false,
    sort: false,
    filter: false,
    type: ColType.LISTADDER
  },
  {
    name: 'start_on',
    title: 'startdate',
    required: false,
    filter: false,
    sort: false,
    type: ColType.DATE
  },
  {
    name: 'end_on',
    title: 'enddate',
    required: false,
    filter: false,
    sort: false,
    type: ColType.DATE
  },
  {
    name: 'dedication',
    title: 'totaldedication',
    required: false,
    filter: false,
    sort: false,
    type: ColType.INT
  },
  {
    name: 'role',
    title: 'projectrole',
    required: false,
    filter: false,
    sort: false,
    type: ColType.LISTADDER
  },
  {
    name: 'invited_at',
    title: 'invited_at',
    required: false,
    filter: false,
    sort: false,
    type: ColType.LISTADDER
  },
  {
    name: 'invited_by',
    title: 'invited_by',
    required: false,
    filter: false,
    sort: false,
    type: ColType.LISTADDER
  },
  {
    name: 'accept_reject',
    title: 'accept_reject',
    required: true,
    disabled: true,
    type: ColType.CUSTOM,
    filter: false,
    sort: false
  }
];
